/* unplugin-vue-components disabled */import "core-js/modules/es.array.includes.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _defineProperty from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//

var prefixCls = 'ivu-alert';
export default {
  name: 'Alert',
  components: {},
  props: {
    type: {
      validator: function validator(value) {
        return ['success', 'info', 'warning', 'error'].includes(value);
      },
      default: 'info'
    },
    closable: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: false
    },
    banner: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      closed: false,
      desc: false
    };
  },
  computed: {
    wrapClasses: function wrapClasses() {
      var _ref;
      return ["".concat(prefixCls), "".concat(prefixCls, "-").concat(this.type), (_ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-with-icon"), this.showIcon), _defineProperty(_ref, "".concat(prefixCls, "-with-desc"), this.desc), _defineProperty(_ref, "".concat(prefixCls, "-with-banner"), this.banner), _ref)];
    },
    messageClasses: function messageClasses() {
      return "".concat(prefixCls, "-message");
    },
    descClasses: function descClasses() {
      return "".concat(prefixCls, "-desc");
    },
    closeClasses: function closeClasses() {
      return "".concat(prefixCls, "-close");
    },
    iconClasses: function iconClasses() {
      return "".concat(prefixCls, "-icon");
    },
    iconType: function iconType() {
      var type = '';
      switch (this.type) {
        case 'success':
          type = 'ios-checkmark-circle';
          break;
        case 'info':
          type = 'ios-information-circle';
          break;
        case 'warning':
          type = 'ios-alert';
          break;
        case 'error':
          type = 'ios-close-circle';
          break;
      }
      if (this.desc) type += '-outline';
      return type;
    }
  },
  methods: {
    close: function close(e) {
      this.closed = true;
      this.$emit('on-close', e);
    }
  },
  mounted: function mounted() {
    this.desc = this.$slots.desc !== undefined;
  }
};